import { useReducer } from 'react';
import { GlobalContext } from './GlobalContext';

const win = window;


!!!win["lang"] && (win["lang"] = "en");
!!!win["sourcePage"] && (win["sourcePage"] = "createOrder");
let dir = win["lang"] === null || win["lang"] === "en" ? "ltr" : "rtl";
const lang = win['lang'];
const rtl = lang === 'ar';
const sourcePage = win['sourcePage']


console.log('lang---->', lang);
console.log('sourcePage--->', sourcePage);
const userType = localStorage.getItem('userType');
const productType = localStorage.getItem('productType');
const initialState = {
    rtl: rtl,
    dir: dir,
    lang: lang,
    userType: userType ? userType : 'existingcustomer',
    productType: productType ? productType : 'Voice',
    existingCustomerData: {
        crNumber: '',
        mobileNumber: '',
        apName: '',
        accountNumber: '',
        email: ''
    },
    existingCustomerAPIRes: {},
    newCustomerData: {
        crNumber: '',
        vatNumber: '',
        ciNumber: '',
        companyName: '',
        address: '',
        firstName: '',
        lastName: '',
        email: '',
        mobileNumber: '',
        idNumber: ''
    },
    deliveryAddressData: {
        city: '',
        districtName: '',
        streetName: '',
        buildingNo: '',
        region: '',
        shortAddress:''
    },
    setQueryData: {
        extid: ' ',
        ctype: ' ',
        ptype: ' ',
        unqid: ' ',
        otype: ' ',
    },
    getQueryData: {
        leadId: ' ',
        customerType: ' ',
        packageType: ' ',
        identifier: ' ',
    },
    newCustomerAPIRes: {},
    downloadAttachmentData: {},
    ReDownloadAttachmentData: {},
    orderDetailsData: {},
    productInformationData: [],
    productInfoAPIData: [],
    productBackListData: [],
    productFormData: {},
    modalOpenOrderDetails: false,
    modalOpenOtpPage: false,
    currentPage: '',
    loading: false,
    trackOrderNumberData: {},
    trackCrNumberData: {},
    tractCrNum: "",
    trackMobileNum: "",
    selectedValue: "",
    sourcePage: sourcePage,
    createdTime: '',
    uniqueId: '',
    comment: ' ',
    orderType: ' ',
    dateString: '',
    randomID: '',
    accountDetails: {},
    newCustomerFieldsTouched: false,
    isSIPformTouched: false,
    nationalities: [],
    cities: [],
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'INITIAL_ONLOAD':
            return {
                ...state,
                currentPage: action.payload.page
            }
        case 'SET_BACK_BUTTON':
            return {
                ...state,
                currentPage: action.payload.page
            }
        case 'EXISTING_CUSTOMER_DATA':
            return {
                ...state,
                existingCustomerData: action.payload.values,
                existingCustomerAPIRes: action.payload.existingCustomerAPIRes,
                currentPage: action.payload.page,
                userType: action.payload.customerType,
                createdTime: action.payload.createdTime,
                uniqueId: action.payload.uniqueId,
                dateString: action.payload.dateString,
                randomID: action.payload.randomID,
                accountDetails: action.payload.result
            }
        case 'NEW_CUSTOMER_DATA':
            return {
                ...state,
                newCustomerData: action.payload.values,
                currentPage: action.payload.page,
                userType: action.payload.customerType,
                createdTime: action.payload.createdTime,
                newCustomerAPIRes: action.payload.newCustomerAPIRes,
                dateString: action.payload.dateString,
                randomID: action.payload.randomID,
                newCustomerFieldsTouched: true,
            }
        case 'UPDATE_EXISTING_CUSTOMER_DATA':
            return {
                ...state,
                currentPage: action.payload.page,
                customerType: action.payload.customerType,
                randomID: action.payload.randomID,
                createdTime: action.payload.createdTime,
            }
        case 'UPDATE_NEW_CUSTOMER_DATA':
            return {
                ...state,
                customerType: action.payload.customerType,
                randomID: action.payload.randomID,
                createdTime: action.payload.createdTime,
                currentPage: action.payload.page,
            }
        case 'PRODUCT_INFORMATION':
            sessionStorage.setItem('productInformationData', JSON.stringify(action.payload.values))
            return {
                ...state,
                productInformationData: action.payload.values,
                currentPage: action.payload.page,
                productInfoAPIData: action.payload.productInfoData,
                productBackListData: action.payload.productList,
                productFormData: action.payload.productFormData ? action.payload.productFormData : {},
                modalOpenOrderDetails: action.payload.modalOpen,
                isSIPformTouched: true,
            }
        case 'DOWNLOAD_ATTACHMENT_DATA':
            return {
                ...state,
                downloadAttachmentData: action.payload.values,
                currentPage: action.payload.page,
                modalOpenOrderDetails: action.payload.modalOpen
            }
        case 'RE_DOWNLOAD_ATTACHMENT_DATA':
            return {
                ...state,
                ReDownloadAttachmentData: action.payload.values,
                currentPage: action.payload.page,
                modalOpenOrderDetails: action.payload.modalOpen,
                isDownloadUpdated: true,
            }

        case 'COMMENT_DATA':
            return {
                ...state,
                comment: action.payload.values,
                isCommentUpdated: true,
            }
        case 'SET_SOURCE_PAGE':
            return {
                ...state,
                sourcePage: action.payload
            }
        case 'SET_LEAD_PARAMS':
            return {
                ...state,
                setQueryData: {
                    extid: action.payload.extid,
                    ctype: action.payload.ctype,
                    ptype: action.payload.ptype,
                    unqid: action.payload.unqid,
                    otype: action.payload.otype
                }

            };
        case 'GET_LEAD_PARAMS':
            return {
                ...state,
                getQueryData: {
                    GetLeadId: action.payload.extid,
                    GetCustomerType: action.payload.ctype,
                    GetPackageType: action.payload.ptype,
                    GetIdentifier: action.payload.unqid,
                }

            }
        case 'SET_USER_TYPE':
            return {
                ...state,
                userType: action.payload,
            }

        case 'SET_PRODUCT_TYPE':
            return {
                ...state,
                productType: action.payload,
            };
        case 'SET_ORDER_TYPE':
            return {
                ...state,
                orderType: action.payload,
            }




        case 'ORDER_DETAILS_DATA':
            return {
                ...state,
                orderDetailsData: action.payload.values,
                currentPage: action.payload.page,
                modalOpenOrderDetails: action.payload.prevModalOpen,
                modalOpenOtpPage: action.payload.modalOpen
            }

        case 'OTP_VERIFICATION_DATA':
            return {
                ...state,
                otpData: action.payload.values,
                currentPage: action.payload.page,
                modalOpenOrderDetails: action.payload.prevModalOpen,
                modalOpenOtpPage: action.payload.modalOpen
            }

        case 'ERROR_PAGE':
            return {
                ...state,
                currentPage: action.payload.page,
            }

        case 'LOADER':
            return {
                ...state,
                loading: action.payload.loading
            }
        case 'DELIVERY_ADDRESS_DATA':
            return {
                ...state,
                deliveryAddressData: action.payload.values,
                currentPage: action.payload.page,
                deliveryAddressFieldsTouched: true,
            }

        case 'INITIAL_ONLOAD_TRACK_ORDER':
            return {
                ...state,
                currentPage: action.payload.page,
            }

        case 'TRACK_ORDER_NUMBER_DATA':
            sessionStorage.setItem('OrderStatusValue', JSON.stringify(action.payload.values));
            return {
                ...state,
                trackOrderNumberData: action.payload.values,
                currentPage: action.payload.page,
            }

        case 'TRACK_CRNUMBER_DATA':
            return {
                ...state,
                trackCrNumberData: action.payload.values,
                trackMobileNum: action.payload.mobileNumber,
                tractCrNum: action.payload.crNumber,
                selectedValue: action.payload.selectValue,
                currentPage: action.payload.page,
            }

        case 'TRACKORDER_ERROR_PAGE':
            return {
                ...state,
                currentPage: action.payload.page,
            }

        case 'UPDATE_NATIONALITIES':
            return {
                ...state,
                nationalities: action.payload,
            }

        case 'UPDATE_CITIES':
            return {
                ...state,
                cities: action.payload,
            }
        case 'RESET_DATA':
            return {
                ...state,
                productInformationData: [],
                productInfoAPIData: [],
                productBackListData: [],
                productFormData: {},
                downloadAttachmentData: {},
                isSIPformTouched: false,
                isDownloadUpdated: false,
                isCommentUpdated: false,
            }

        default:
            return state;
    }
}

export const GlobalProvider = props => {
    const [state, dispatch] = useReducer(reducer, initialState)

    return (
        <GlobalContext.Provider value={[state, dispatch]}>
            {props.children}
        </GlobalContext.Provider>
    )
}